'use strict';

var React = require('react');

// This is internal, but TS throws a build-time error if we don't export it

const ResourceListContext = /*#__PURE__*/React.createContext({});

exports.ResourceListContext = ResourceListContext;
